<template>
  <div class="no-table-data flex flex-column flex-h-center flex-v-center">
    <img src="/img/no-data.svg" alt="no data" class="mb-20" />
    <!-- <p class="center-text mt-20">{{ message }}</p> -->
    <slot name="message"></slot>
    <router-link
      :to="link"
      v-if="showButton"
      class="btn blue btn-outline btn-full-radius inline-flex flex-v-end mt-20"
    >
      <img src="/img/pencil-b.svg" alt="new record" class="mr-5" />
      <span>Create {{ btnText }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    showButton: {
      type: Boolean,
      default: false,
    },
    route: {
      type: String,
    },
    image: {
      type: String,
      default: "/img/no-data.svg",
    },
    btnText: {
      type: String,
    },
    message: {
      type: String,
      default: `You are yet to create some data`,
    },
    link: {
      type: String,
      default: ``,
    },
  },
};
</script>
<style>
.padding {
  padding: 100px 0;
  background: #fff;
}

.no-table-data {
  margin-left: auto;
  margin-right: auto;
}
</style>
